import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ghatkopartopunecab() {



const cardData = {
  keyword: " Ghatkopar to Pune Cab Service  ",

headingDescription: "Velocity Cab provides reliable and comfortable Ghatkopar to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Ghatkopar to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Ghatkopar to Pune cab travel.",

topPlaces: [
 
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most famous religious landmarks dedicated to Lord Ganesha. It attracts thousands of devotees daily and is especially vibrant during festivals."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a peaceful riverside park offering greenery, walking paths, and boating activities. It is a popular place for relaxation and evening strolls in Pune."
  },
   {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautifully maintained Japanese-style garden featuring serene landscapes, water streams, and lush greenery. Travelers booking a sedan cab in Pune can enjoy peaceful walks, photography, and a relaxing break from the city's busy environment."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular garden in Pune known for its scenic surroundings and the famous Siddhivinayak Temple located inside. It is a favorite spot for families, morning walkers, and visitors looking for a calm and refreshing atmosphere."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a historic site in Pune offering panoramic views of the city from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy breathtaking sunset views over Pune."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a significant monument in Indian history associated with Mahatma Gandhi and the freedom movement. It features elegant architecture, spacious gardens, and a museum showcasing important historical artifacts."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its unique architecture and peaceful spiritual environment."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum houses a vast collection of Indian antiques, musical instruments, sculptures, and cultural artifacts. It provides a rich insight into India’s traditional art and heritage."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification that was once the seat of the Peshwas. Visitors can explore its massive gates, ruins, and experience the light and sound show that narrates its glorious past."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a leading shopping and entertainment destination featuring international brands, restaurants, cinemas, and entertainment zones for visitors of all ages."
  }
],



services: [
{
name: "Ghatkopar to Pimple Saudagar Cabs",
description: "Ghatkopar to Pimple Saudagar cab service offers reliable intercity transportation between Ghatkopar in Mumbai and the Pimple Saudagar area of Pune. Travelers can enjoy smooth highway travel via the Mumbai–Pune Expressway in comfortable vehicles such as sedan, Ertiga, and Innova. Professional drivers provide punctual pickups from residential complexes, offices, and hotels across Ghatkopar East and West. This service is ideal for corporate travelers, families, and tourists visiting PCMC areas. Air-conditioned vehicles and spacious seating ensure a comfortable long-distance journey. Online booking options allow passengers to reserve rides instantly with transparent pricing and flexible scheduling."
},
{
name: "Ghatkopar to Pune One Way Cab",
description: "Ghatkopar to Pune one way cab service provides economical transportation for passengers traveling from Mumbai to Pune without paying for return fares. Comfortable vehicles including sedan, Ertiga, and Innova ensure smooth expressway travel. Professional drivers provide timely pickup services from homes, offices, and hotels across Ghatkopar. This service is widely used for airport transfers, corporate trips, and personal visits to Pune. Air-conditioned vehicles and spacious seating ensure relaxed travel throughout the journey."
},
{
name: "Pune to Mumbai Taxi Service",
description: "Pune to Mumbai taxi service offers dependable intercity transportation between the two cities. Travelers can book comfortable vehicles such as sedan, Ertiga, and Innova for smooth travel through the Mumbai–Pune Expressway. Professional drivers provide punctual pickups from residential areas, offices, hotels, and railway stations across Pune. This service is ideal for airport transfers, corporate travel, tourist trips, and family journeys. Spacious seating and air-conditioned vehicles ensure comfortable long-distance travel."
},
{
name: "Ghatkopar to Pune Baner Taxi Fare",
description: "Ghatkopar to Baner Pune taxi service provides convenient transportation between Ghatkopar in Mumbai and the Baner area of Pune. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and punctual pickups. This service is widely used by corporate travelers visiting IT companies and offices in Baner. Spacious vehicles and air-conditioned interiors make the long-distance journey comfortable."
},
{
name: "Ghatkopar to Kondhwa Pune Taxi",
description: "Ghatkopar to Kondhwa Pune taxi service offers reliable transportation between Mumbai and the Kondhwa area of Pune. Travelers can choose vehicles such as sedan, Ertiga, and Innova depending on comfort and group size. Professional drivers ensure safe expressway travel and punctual pickups from homes and offices across Ghatkopar. Air-conditioned vehicles and comfortable seating ensure relaxed long-distance travel."
},
{
name: "Mumbai Ghatkopar to Pune Taxi Fare",
description: "Mumbai Ghatkopar to Pune taxi fare service provides transparent pricing for passengers traveling between the two cities. Travelers can choose vehicles according to comfort and budget preferences including sedan, Ertiga, and Innova. Professional drivers provide punctual pickups and safe highway driving through the Mumbai–Pune Expressway. Clear fare details help passengers plan their travel budget easily."
},
{
name: "Mumbai to Kothrud Pune Cab Fare",
description: "Mumbai to Kothrud Pune cab service offers reliable intercity transportation between Mumbai and the Kothrud area of Pune. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and punctual pickups from multiple Mumbai locations including Ghatkopar. This service is ideal for corporate travelers, students, and families visiting Pune."
},
{
name: "Ghatkopar to Pune Ertiga Taxi Fare",
description: "Ghatkopar to Pune Ertiga taxi service offers spacious 7-seater SUV travel for families and small groups. The Maruti Ertiga provides comfortable seating, air-conditioning, and smooth highway performance. Professional drivers ensure punctual pickups from Ghatkopar and safe expressway travel. This service is ideal for airport transfers, corporate travel, and family trips."
},
{
name: "Ghatkopar to Pune Innova Crysta Taxi",
description: "Ghatkopar to Pune Innova Crysta taxi service provides premium SUV travel for passengers seeking luxury and comfort. The Toyota Innova Crysta offers spacious seating, excellent suspension, and smooth highway performance. Professional drivers provide safe driving and punctual pickups from homes and offices in Ghatkopar. This service is ideal for corporate travel, family trips, and group journeys."
},
{
name: "Cab Service in Ghatkopar Mumbai",
description: "Cab service in Ghatkopar Mumbai provides convenient transportation for city travel, airport transfers, and outstation journeys. Travelers can choose from comfortable vehicles such as sedan, Ertiga, and Innova depending on their travel needs. Professional drivers ensure safe driving and punctual pickups from homes, offices, and hotels across Ghatkopar."
},
{
name: "Taxi Service in Ghatkopar",
description: "Taxi service in Ghatkopar offers reliable transportation for passengers traveling within Mumbai and for outstation trips to cities like Pune, Nashik, and Lonavala. Comfortable vehicles and experienced drivers ensure safe and convenient journeys for passengers."
},
{
name: "Taxi Service in Mumbai for Outstation",
description: "Taxi service in Mumbai for outstation travel provides long-distance transportation to destinations such as Pune, Shirdi, Lonavala, and Nashik. Comfortable vehicles ensure smooth highway travel while professional drivers maintain safe driving standards throughout the journey."
},
{
name: "Outstation Taxi Service in Ghatkopar",
description: "Outstation taxi service in Ghatkopar provides reliable long-distance transportation from Mumbai to destinations like Pune, Nashik, and Lonavala. Travelers can book comfortable vehicles with experienced drivers for safe and convenient travel."
},
{
name: "Outstation Taxi Service in Ghatkopar Number",
description: "Outstation taxi service in Ghatkopar contact support helps passengers quickly book taxis for long-distance travel. Travelers can connect with reliable cab providers to schedule comfortable rides to Pune and other nearby destinations."
},
{
name: "Best Cab in Ghatkopar",
description: "Best cab service in Ghatkopar offers premium transportation with well-maintained vehicles and professional drivers. Travelers can enjoy comfortable rides for city travel, airport transfers, and outstation journeys including Pune trips."
},
{
name: "Ghatkopar to Pune Cab",
description: "Ghatkopar to Pune cab service provides dependable intercity transportation between Mumbai and Pune. Comfortable vehicles ensure smooth expressway travel while experienced drivers provide safe driving and punctual pickups."
},
{
name: "Ghatkopar to Pune Taxi",
description: "Ghatkopar to Pune taxi service offers convenient transportation between the two cities with comfortable vehicles and professional drivers ensuring smooth highway journeys."
},
{
name: "Ghatkopar to Pune Cab Service",
description: "Ghatkopar to Pune cab service offers reliable long-distance transportation between Mumbai and Pune. Travelers benefit from comfortable vehicles, experienced drivers, and smooth expressway travel."
},
{
name: "Ghatkopar to Pune Taxi Booking",
description: "Ghatkopar to Pune taxi booking allows passengers to easily reserve taxis through online platforms. Travelers can schedule rides according to their preferred timing and vehicle choice."
},
{
name: "Ghatkopar to Pune Drop Taxi",
description: "Ghatkopar to Pune drop taxi service offers convenient one-way transportation between the two cities with affordable fares and comfortable vehicles."
},
{
name: "Ghatkopar to Pune Online Cab Booking",
description: "Ghatkopar to Pune online cab booking allows passengers to reserve taxis instantly through websites or mobile platforms. Travelers benefit from transparent pricing and instant confirmation."
},
{
name: "Ghatkopar to Pune Private Cab",
description: "Ghatkopar to Pune private cab service provides exclusive transportation for passengers seeking privacy and comfort. Travelers enjoy direct travel without ride sharing and flexible pickup timing."
},
{
name: "Ghatkopar to Pune Outstation Cab",
description: "Ghatkopar to Pune outstation cab service provides dependable long-distance travel with comfortable vehicles and experienced drivers. This service is ideal for business travel, family trips, and weekend visits."
},
{
name: "Ghatkopar to Pune Cheap Cab",
description: "Ghatkopar to Pune cheap cab service offers budget-friendly transportation for travelers seeking economical intercity travel. Comfortable vehicles and reliable drivers ensure safe journeys."
},
{
name: "Ghatkopar to Pune AC Cab Service",
description: "Ghatkopar to Pune AC cab service offers comfortable air-conditioned vehicles for long-distance travel. Passengers can enjoy relaxed journeys with professional drivers and smooth expressway travel."
},
{
name: "Ghatkopar to Pune Innova Cab",
description: "Ghatkopar to Pune Innova cab service provides spacious SUV travel for families and groups. Toyota Innova vehicles ensure comfortable seating and smooth highway travel."
},
{
name: "Ghatkopar to Pune Taxi Fare",
description: "Ghatkopar to Pune taxi fare service provides clear pricing information for travelers planning intercity journeys. Transparent fare details help passengers plan their travel budget easily."
}
],

tableData: [
["Ghatkopar to Pimple Saudagar Cabs","Ghatkopar to Pune One Way Cab"],
["Pune to Mumbai Taxi Service","Ghatkopar to Pune Baner Taxi Fare"],
["Ghatkopar to Kondhwa Pune Taxi","Mumbai Ghatkopar to Pune Taxi Fare"],
["Mumbai to Kothrud Pune Cab Fare","Ghatkopar to Pune Ertiga Taxi Fare"],
["Ghatkopar to Pune Innova Crysta Taxi","Cab Service in Ghatkopar Mumbai"],
["Taxi Service in Ghatkopar","Taxi Service in Mumbai for Outstation"],
["Outstation Taxi Service in Ghatkopar","Outstation Taxi Service in Ghatkopar Number"],
["Best Cab in Ghatkopar","Ghatkopar to Pune Cab"],
["Ghatkopar to Pune Taxi","Ghatkopar to Pune Cab Service"],
["Ghatkopar to Pune Taxi Booking","Ghatkopar to Pune Drop Taxi"],
["Ghatkopar to Pune Online Cab Booking","Ghatkopar to Pune Private Cab"],
["Ghatkopar to Pune Outstation Cab","Ghatkopar to Pune Cheap Cab"],
["Ghatkopar to Pune AC Cab Service","Ghatkopar to Pune Innova Cab"],
["Ghatkopar to Pune Taxi Fare","Ghatkopar to Pune Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Ghatkopar to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Ghatkopar to Pune cab service bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Ghatkopar to Pune cab service operates 24 hours a day. Whether you need an early morning ride, airport transfer, business travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Ghatkopar to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Ghatkopar",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Ghatkopar including Ghatkopar East, Ghatkopar West, and nearby locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Ghatkopar to Pune cab service bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Ghatkopar to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Ghatkopar to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Ghatkopar from Pune?", answer: "The road distance between Ghatkopar and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Ghatkopar to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Ghatkopar to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Ghatkopar to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Ghatkopar and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Ghatkopar." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Ghatkopar to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh More",
    feedback:
      "The journey from Ghatkopar to Pune was very comfortable and well-managed. The cab was clean, the driver was punctual, and the ride felt smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Joshi",
    feedback:
      "Traveling from Ghatkopar to Pune was a pleasant experience. The pickup was on time, the vehicle was well-maintained, and the entire trip was safe and hassle-free.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ghatkopar to Pune Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Ghatkopar to Pune cab service with professional drivers, affordable fares, and comfortable rides. Book one way or round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for city travel, airport transfers, and corporate trips from Ghatkopar to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};



  return (
    <div>
      

<Helmet>
  <title>Ghatkopar to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Ghatkopar to Pune cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for city travel, airport transfers & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ghatkopartopunecab;